import { Form, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { AdminBuildingApi } from 'gmrfid-service-community-api-manager'
import { HouseApi } from 'gmrfid-service-community-api-client'

const { Option } = Select;

const RoomNumberItem = ({ form, isH5, required, disabled, villageId, selectAllCallBack, hasLabel = false, label = '房号', ...props }) => { // hasLabel是否需要label
  const [HouseUser, setHouseUser] = useState([])
  const [unitArr, setUnitArr] = useState([])
  const [houseIdArr, setHouseIdArr] = useState([])
  const [floorArr, setFloorArr] = useState([])
  useEffect(() => {
    AdminBuildingApi.getBuildingList({ villageId }).then(res => {
      setHouseUser(res.data)
    })
  }, [villageId])

  const handleSelect = e => {
    const item = HouseUser.filter(v => v.number === e)[0]
    AdminBuildingApi.getFloorListByBuilding({
      param: {
        number: item.number,
        villageId
      }
    }).then(res => {
      setUnitArr(res.data)
    })
    form.resetFields(['buildingId', 'floor', 'houseId','unit'])
    setFloorArr([])
    setHouseIdArr([])
  }
  const handleUnit = (e, data) => {
    const arr = unitArr
    const objs = arr.filter(v => v.buildingId == e)[0] || {}
    // const list = []
    // for (let i = 0; i < objs.floor; i++) {
    //   list.push({ floor: i + 1, key: objs.buildingId })
    // }
    setFloorArr(objs.floorDetails)
    form.resetFields(['floor', 'houseId'])
    form.setFieldValue('unit',data.children)
  }
  const handleHouseNo = (e, data) => {
    form.setFieldValue('houseNo',data.children)
  }
  const onSelect = e => {
    const item = floorArr.filter(v => v == e)[0]
    if (item) {
      HouseApi.simpleList({
        param: {
          buildingId: form.getFieldValue('buildingId'),
          floor: form.getFieldValue('floor'),
          villageId
        }
      }).then(res => {
        setHouseIdArr(res.data)
      })
    } else {
      setHouseIdArr([])
    }
    form.resetFields(['houseId'])
  }
  const houseId = Form.useWatch('houseId', form)
  useEffect(() => {
    if (houseId) {
      const { number, buildingId, floor,unit } = form.getFieldsValue(true)
      selectAllCallBack?.({
        number,
        buildingId,
        floor,
        houseId,
        unit
      })
    }
  }, [houseId])
  return (
    <Form.Item
      label={hasLabel ? '' : label}
      name="houseId"
      {...props}
      rules={[
        {
          required,
          message: '请输入'
        }
      ]}
    >
      <div
        className="flex"
        style={{
          display: 'flex'
        }}
      >
        <Form.Item noStyle name="number">
          <Select disabled={disabled} placeholder={isH5 ? '楼栋' : '选择楼栋'} onSelect={e => handleSelect(e)}>
            {HouseUser.map(item => (
              <Option key={item.number}>{item.number}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="buildingId" noStyle>
          <Select disabled={disabled} placeholder={isH5 ? '单元' : '选择单元'} onSelect={(e,option)=> handleUnit(e,option)}>
            {unitArr.map(item => (
              <Option key={item.buildingId}>{item.unit}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="unit" hidden>
        </Form.Item>
        <Form.Item disabled={disabled} name="floor" noStyle>
          <Select placeholder={isH5 ? '楼层' : '选择楼层'} onSelect={e => onSelect(e)}>
            {floorArr && floorArr.map(item => <Option key={item}>{item}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item disabled={disabled} name="houseId" noStyle>
          <Select placeholder={isH5 ? '房号' : '选择房号'} allowClear onSelect={(e,option)=> handleHouseNo(e, option)}>
            {houseIdArr && houseIdArr.map(item => <Option key={item.houseId}>{item.houseNo}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item name="houseNo" hidden>
        </Form.Item>
      </div>
    </Form.Item>
  )
}

export default RoomNumberItem
